import { render, staticRenderFns } from "./CategoryListChild.vue?vue&type=template&id=13acccd6&"
import script from "./CategoryListChild.vue?vue&type=script&lang=js&"
export * from "./CategoryListChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports